/** Sub subject options when meeting agenda (subject) is Sales */
export const SALES_SUB_SUBJECT_OPTIONS = [
  { id: 'Prospect', name: 'Prospect' },
  { id: 'Approach', name: 'Approach' },
  { id: 'Negotiation', name: 'Negotiation' },
  { id: 'Closure', name: 'Closure' },
];

export const isSalesMeetingAgenda = (subject) =>
  subject != null && String(subject).trim().toLowerCase() === 'sales';

export const isLertAssessmentAgenda = (subject) =>
  subject != null && String(subject).trim().toLowerCase() === 'lert assessment';

export const RISK_CATEGORY_OPTIONS = [
  { id: 'Pricing Concern', name: 'Pricing Concern' },
  { id: 'Service Issues', name: 'Service Issues' },
  { id: 'Competitor Activity', name: 'Competitor Activity' },
  { id: 'Payment Delays', name: 'Payment Delays' },
  { id: 'Committee Change', name: 'Committee Change' },
  { id: 'Contract Exit Request', name: 'Contract Exit Request' },
  { id: 'Other', name: 'Other' },
];

export const CHURN_RISK_OPTIONS = [
  { id: 'Low', name: 'Low' },
  { id: 'Medium', name: 'Medium' },
  { id: 'High', name: 'High' },
  { id: 'Critical', name: 'Critical' },
];

export const isLertAssessmentFormReady = (formData = {}) =>
  String(formData.body || '').trim() !== '' &&
  formData.risk_category !== '' &&
  formData.churn_risk !== '' &&
  (formData.risk_category !== 'Other' ||
    String(formData.risk_category_other || '').trim() !== '');

export const LERT_ASSESSMENT_FIELD_RESET = {
  sub_subject: '',
  remark: '',
  attachment: '',
  paymentPicked: '',
  paymentMode: '',
  chequeRemark: '',
  opportunity: [],
  saleType: '',
  feedback_dropdown: '',
  client_reason: '',
  dashboard_check: '',
  dashboard_reason: '',
  training_check: '',
  training_reason: '',
  complaint_check: '',
  complaint_reason: '',
  whatsapp_check: '',
  whatsapp_reason: '',
  vms_check: '',
  vms_type: '',
  vms_others_reason: '',
  vms_duration: '',
  vms_usage: '',
  vms_paid: '',
  vms_paid_type: '',
  vms_maintenance_check: '',
  vms_maintenance_type: '',
  vms_maintenance_remark: '',
  crm_check: '',
  alignment_check: '',
  alignment_reason: '',
  car_check: '',
  car_reason: '',
  sampling_reason: '',
  sampling_check: '',
  kiosking_reason: '',
  kiosking_check: '',
  door_reason: '',
  door_check: '',
  waiting_time: '',
  flat_cost: '',
  monthly_main_fees: '',
  facility_management: '',
  flat_count: '',
  locality: '',
  is_upselling_opportunity_exist: '',
  existing_upselling_opportunity: [],
  existing_upselling_opportunity_other: '',
  product_list: [],
  renewal_outcome: '',
  followup_date: '',
  followup_remark: '',
  cheque_pickup_type: '',
  other_remark: '',
  adsales_type: '',
  carnival_type: '',
  referral_discussed: '',
  did_client_refer_lead: '',
  referral_no_reason: '',
  client_reffer_no: '',
  type_of_referral: '',
  whatsapp_upload: '',
  for_hot_nego_sites: '',
  not_hot_nego_sites_reason: '',
  referral_shared_image: '',
  shared_referral_message: '',
  not_shared_referral_reason: '',
  got_video_testimonial: '',
  no_video_testimonial_reason: '',
};

export const EMPTY_PAYMENT_INPUT_ITERATION = [
  {
    invoice_number: '',
    cheque_trnx_no: '',
    cheque_trnx_date: '',
    bank: '',
    amount: '',
    document: '',
    invoice_name: '',
    tds_amount: '',
    document_type: '',
  },
];

export const applyLertAssessmentFieldReset = (formData = {}) => ({
  ...formData,
  ...LERT_ASSESSMENT_FIELD_RESET,
});

export const buildLertAssessmentMeetingPayload = (formData = {}, extras = {}) => ({
  site_id: formData.site_id ?? '',
  other_site_id: formData.other_site_id ?? null,
  poc: formData.poc ?? '',
  others_email: formData.others_email ?? '',
  scheduled_date: formData.scheduled_date ?? '',
  scheduled_time: formData.scheduled_time ?? '',
  subject: formData.subject ?? '',
  sub_subject: '',
  status: formData.status ?? 1,
  body: formData.body ?? '',
  client_id: formData.client_id ?? '',
  client_category: formData.client_category ?? 1,
  client: formData.client ?? 'NA',
  poc_name: formData.poc_name ?? '',
  mobile_number: formData.mobile_number ?? '',
  email_id: formData.email_id ?? '',
  poc_remark: formData.poc_remark ?? '',
  risk_category: formData.risk_category ?? '',
  risk_category_other: formData.risk_category_other ?? '',
  churn_risk: formData.churn_risk ?? '',
  other_site: formData.other_site ?? null,
  other_client_name: formData.other_client_name ?? null,
  other_client_email: formData.other_client_email ?? null,
  opportunity: [],
  existing_upselling_opportunity: [],
  product_list: [],
  inputIteration: EMPTY_PAYMENT_INPUT_ITERATION,
  ...extras,
});

export const getMeetingPayloadForSubject = (formData = {}, extras = {}) =>
  isLertAssessmentAgenda(formData?.subject)
    ? buildLertAssessmentMeetingPayload(formData, extras)
    : { ...formData, ...extras };

export const getSubSubjectFromDraft = (draftData = {}) =>
  draftData?.sub_subject ??
  draftData?.draft_data?.sub_subject ??
  draftData?.checkout_details?.sub_subject ??
  '';
